module.exports = __webpack_public_path__ + "static/media/pdf_multiu_header.d3262711.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pdf_multiu_header.png
// module id = 459
// module chunks = 0